// const API_BASE_URL = "http://localhost:5000/";
const API_BASE_URL = "https://summit-clinic-api.sits.work/";

export const roleAccess = {
  Admin: [
    "/dashboard",
    "/doctor-master",
    "/test-master",
    "/problem-master",
    "/daily-collection-report",
    "/doctor-wise-report",
    "/test-wise-report",
  ],
  Doctor: ["/dashboard", "/waiting", "/doctor-wise-report"],
  Operator: [
    "/dashboard",
    "/counter-registration",
    "/edit-patient-details",
    "/follow-up",
    "/patient-test",
    "/daily-collection-report",
    "/doctor-wise-report",
    "/test-wise-report",
    "/cancel-appointment",
    "/refund",
  ],
};

export default API_BASE_URL;
